import { Link } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { HelpOutlineOutlined, LaunchOutlined, LinkOutlined, SaveAltOutlined } from "@material-ui/icons";
import MoreIcon from "@material-ui/icons/MoreVert";
import PropTypes from "prop-types";
import React from "react";

const styles = (theme) =>
	createStyles({
		root: {
			width: "100%",
		},
		grow: {
			flexGrow: 1,
		},
		inputRoot: {
			color: "inherit",
			width: "100%",
		},
		inputInput: {
			paddingTop: theme.spacing(0),
			paddingRight: theme.spacing(0),
			paddingBottom: theme.spacing(0),
			paddingLeft: theme.spacing(10),
			transition: theme.transitions.create("width"),
			width: "100%",
			[theme.breakpoints.up("md")]: {
				width: 200,
			},
		},
		sectionDesktop: {
			display: "none",
			[theme.breakpoints.up("md")]: {
				display: "flex",
			},
		},
		sectionMobile: {
			display: "flex",
			[theme.breakpoints.up("md")]: {
				display: "none",
			},
		},
	});

interface Props {
	classes: any;
}

class Manual extends React.Component<Props> {
	state = {
		anchorEl: null,
		mobileMoreAnchorEl: null,
	};

	handleProfileManualOpen = (event) => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleManualClose = () => {
		this.setState({ anchorEl: null });
		this.handleMobileManualClose();
	};

	handleMobileManualOpen = (event) => {
		this.setState({ mobileMoreAnchorEl: event.currentTarget });
	};

	handleMobileManualClose = (): void => {
		this.setState({ mobileMoreAnchorEl: null });
	};
	static propTypes: { classes: PropTypes.Validator<object> };

	render() {
		const { anchorEl, mobileMoreAnchorEl } = this.state;
		const { classes } = this.props;
		const isManualOpen = Boolean(anchorEl);
		const isManualMobileOpen = Boolean(mobileMoreAnchorEl);
		// tslint:disable-next-line:max-line-length
		const local =
			"https://www.bnb.gov.br/documents/45767/448145/Manual+de+Operacionaliza%C3%A7%C3%A3o+T%C3%A9cnica+-+Vers%C3%A3o+2.0+-+21-10-2024.pdf/701b4f62-b114-cbc8-0716-35e87334d039";
		const renderMenu = (
			<Menu
				anchorEl={anchorEl ? anchorEl : mobileMoreAnchorEl}
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				open={isManualOpen ? isManualOpen : isManualMobileOpen}
				onClose={isManualOpen ? this.handleManualClose : this.handleMobileManualClose}
			>
				<div onClick={this.handleManualClose}>
					<Link target="_blank" href={local} style={{ margin: 10 }}>
						Manual de Operacionalização - Versão Técnico
						<IconButton color="inherit">
							<LinkOutlined />
						</IconButton>
					</Link>
				</div>
			</Menu>
		);

		return (
			<div>
				<div className={classes.grow} />
				<div className={classes.sectionDesktop}>
					<IconButton aria-owns={isManualOpen ? "material-appbar" : undefined} aria-haspopup="true" onClick={this.handleProfileManualOpen} color="inherit">
						<HelpOutlineOutlined />
					</IconButton>
				</div>
				<div className={classes.sectionMobile}>
					<IconButton aria-haspopup="true" onClick={this.handleMobileManualOpen} color="inherit">
						<MoreIcon />
					</IconButton>
				</div>
				{renderMenu}
			</div>
		);
	}
}

Manual.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Manual);
